import {useIsDesktop} from '../../../shared/hooks/useIsDesktop';
import {Screens} from '../../../shared/routing';
import {NotificationResponsePayload} from '../../../shared/models/api';
import * as React from 'react';

const BLOCKED_CARD_TOPIC = 'ваша еск заблокирована';

export const useNotificationPressHandler = (
  notification: NotificationResponsePayload | null,
  nav: {navigate: (...args: any[]) => void},
): null | (() => void) => {
  const isDesktop = useIsDesktop();
  const pressHandler = React.useCallback(() => {
    const id = notification?.referenceId;
    switch (notification?.referenceType) {
      case 'usc':
        nav.navigate(Screens.Profile);
        break;
      case 'application':
        nav.navigate(
          ...(isDesktop
            ? [Screens.ProfileApplications, {'application-id': id}]
            : [Screens.Profile, {screen: Screens.ProfileApplicationsItem, params: {'application-id': id}}]),
        );
        break;
      case 'request':
        nav.navigate(
          ...(isDesktop
            ? [Screens.SupportServiceTopics, {id}]
            : [
                Screens.MainTabs,
                {screen: Screens.SupportServiceTab, params: {screen: Screens.SupportServiceTopic, params: {id}}},
              ]),
        );
        break;
      case 'poll':
        nav.navigate(
          ...(isDesktop
            ? [Screens.PollsTypeVoteForm, {pollId: id}]
            : [
                Screens.MainTabs,
                {screen: Screens.PollsMenu, params: {screen: Screens.PollsTypeVoteForm, params: {pollId: id}}},
              ]),
        );
        break;
      case 'news':
        nav.navigate(
          ...(isDesktop
            ? [Screens.NewsArticle, {id}]
            : [Screens.MainTabs, {screen: Screens.News, params: {screen: Screens.NewsArticle, params: {id}}}]),
        );
        break;
      case 'socHelp':
        nav.navigate(
          ...(isDesktop
            ? [Screens.PrivilegesServiceDetails, {ssmCode: id}]
            : [
                Screens.MainTabs,
                {
                  screen: Screens.CardServicesMenu,
                  params: {screen: Screens.PrivilegesServiceDetails, params: {ssmCode: id}},
                },
              ]),
        );
        break;
      case 'ecard':
        nav.navigate(
          ...(isDesktop
            ? [Screens.TransportService]
            : [Screens.MainTabs, {screen: Screens.CardServicesMenu, params: {screen: Screens.TransportService}}]),
        );
        break;
      case 'contact':
        nav.navigate(
          ...(isDesktop ? [Screens.DesktopProfileSettings] : [Screens.Profile, {screen: Screens.ProfileUserContacts}]),
        );
        break;
      case 'counterpartyLinkedProfile':
        nav.navigate(
          ...(isDesktop ? [Screens.DesktopProfileMe] : [Screens.Profile, {screen: Screens.ProfileLinkedAccounts}]),
        );
        break;
    }
  }, [notification, isDesktop]);
  return notification?.referenceType && notification.topic?.toLowerCase() !== BLOCKED_CARD_TOPIC ? pressHandler : null;
};
